/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import places from './places'
import users from './users'
import contacts from './contacts'
import posts from './posts'
// import dashboard from './dashboard'

// Array of sections
export default [...places, ...users, ...contacts, ...posts]
